export const secondApiService = {
    searchFaces: async (imageFile, { signal } = {}) => {
        try {
            const formData = new FormData();
            formData.append('image', imageFile);

            console.log('Submitting image for Web Enhanced 2 face search...');

            const response = await fetch('/api/second-api-search', {
                method: 'POST',
                body: formData,
                signal,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Web Enhanced 2 face search failed');
            }

            const data = await response.json();
            
            // Extensive debugging
            console.log('Web Enhanced 2 Raw Response:', data);
            console.log('Matches count:', data.matches ? data.matches.length : 'No matches');
            
            // Log the first match for debugging
            if (data.matches && data.matches.length > 0) {
                console.log('First match example:', data.matches[0]);
            }

            // Ensure we have a valid response with matches
            if (!data.success || !data.matches || data.matches.length === 0) {
                console.warn('No matches found in Web Enhanced 2 search');
                return {
                    success: false,
                    source: 'RBI Web Enhanced 2',
                    matches: [],
                    error: 'No matches found'
                };
            }

            // Transform results to match the exact structure expected by FaceCollectionSearch
            const transformedResult = {
                success: true,
                source: 'RBI Web Enhanced 2',
                matches: data.matches.map((match, index) => ({
                    id: match.id || `web-enhanced-2-${index}`,
                    score: parseFloat(match.score) || 0,
                    url: match.url || '',
                    thumbnail: match.thumbnail || '',
                    metadata: match.metadata || {
                        source: 'RBI Web Enhanced 2'
                    }
                }))
            };
            
            console.log('Transformed result:', transformedResult);
            
            return transformedResult;
        } catch (error) {
            if (error.name === 'AbortError') throw error;
            console.error('Web Enhanced 2 search error:', error);
            return {
                success: false,
                source: 'RBI Web Enhanced 2',
                matches: [],
                error: error.message || 'Unable to perform Web Enhanced 2 search'
            };
        }
    }
};
